// extracted by mini-css-extract-plugin
export default {"btns":"LineaCard_btns__KdbVc","active":"LineaCard_active__eXNoI","page2":"LineaCard_page2__jKSMQ"};